import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementDailyConsumptionConsentAccepted_Agreement on AgreementType {
            __typename
            consents {
                collectDailyConsumptionData
            }
        }
    `),
}

type IsAgreementDailyConsumptionConsentAcceptedProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementDailyConsumptionConsentAccepted(
    props: IsAgreementDailyConsumptionConsentAcceptedProps
) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return !!agreement.consents?.collectDailyConsumptionData
}

isAgreementDailyConsumptionConsentAccepted.fragments = graphQLFragments
